module.exports = __webpack_public_path__ + "static/media/visa.77227823.svg";